import React, { useState, useEffect } from 'react';
import styles from './rejectionEmailModal.module.scss';
import { Container, Col, Modal, Button } from 'react-bootstrap';
import CSSLoader from '../../../../shared/cssLoader';
import EmailReview from './emailReview';
import EmailDetails from './emailDetails';
import { getRejectEmailTemplateConfigs, submitRejectEmailTemplate } from '../../../../../services/util/hiringpipeline/emailAutomation';

function RejectionEmailModal(props) {
    let [step, setStep] = useState(1);
    let [pipelineValues, setPipelineValues] = useState(props.pipelineValues);
    let [emailData,setEmailData] = useState({
        templateWrapper:'',
        templateBody:null,
        email_subject:'',
        email_account_choice:null
    })
    let [isLoading, setLoading] = useState(false);
    let [isEmailActive, setIsEmailActive] = useState(false);
    let [submissionLoading,setSubmissionLoading] = useState(false);

    function nextPage(value) {
        setStep(value)
    }
    function previousPage(value) {
        setStep(value)
    }

    const onSubmitEmailData = (values) =>{
        setEmailData((prevState) => ({
            ...prevState,
            templateBody: values.emailBody,
            email_subject: values.emailSubject

        }));
        nextPage(2);
    }

    const getInitialValues = async() =>{
        setLoading(true);
        let respond = await getRejectEmailTemplateConfigs(pipelineValues);
        if(respond.success === true){
            setEmailData(respond.data);
            setIsEmailActive(respond.data.is_reject_email_enable);
            setLoading(false);
        }else{
            setLoading(false);
        }
    }

    const submitEmailTemplateValues = async() =>{
        setSubmissionLoading(true);
        let respond = await submitRejectEmailTemplate(pipelineValues, emailData.email_subject, emailData.templateBody, isEmailActive);
        if(respond.success === true){
            setSubmissionLoading(false);
            props.handleClose();
            props.getPipelineValues();
        }else{
            setSubmissionLoading(false);
        }
    }

    useEffect(() => {
        getInitialValues();
    }, []);
    
    return (
        <div>
            <Modal
                show={props.showModal}
                onHide={props.handleClose}
                backdrop="static"
                keyboard={false}
                centered
                size="md"
            >
                <Modal.Body  className={styles.modalBodyWrapper}>
                    <div className={styles.modalCancelBtnDiv}>
                        <Button className={styles.modalCancelBtn} onClick={props.handleClose}>
                            <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M13.5 4.5L4.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                <path d="M4.5 4.5L13.5 13.5"  strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button>
                    </div>

                    <div className={styles.modalHeaderDiv}>
                        <h2 className={styles.modalHeader}>Reject Email Template</h2>
                    </div>
                    <Col sm={{ span: 8, offset: 2 }} className={styles.stepPosition}>

                        <div className={step === 1 ? `${styles.roundStepMainDiv}` : step === 2 ? `${styles.roundStepMainDiv} ${styles.roundStepMainDiv2}` : `${styles.roundStepMainDiv}`}>
                            <div className={styles.stepActive}>
                                {
                                    step === 1 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g clip-path="url(#clip0_613_29628)">
                                                <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                            </g>
                                            <defs>
                                                <clipPath id="clip0_613_29628">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                </clipPath>
                                            </defs>
                                        </svg>
                                }

                            </div>
                            <div className={step === 2 ? styles.stepActive : ''}>
                                {
                                    step === 2 ?
                                        <svg className={styles.svgRound} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <g id="Content">
                                                <rect width="24" height="24" rx="12" fill="#ECFAFD" />
                                                <circle id="Dot" cx="12" cy="12" r="4" fill="#2DA6C0" />
                                            </g>
                                        </svg>
                                        :
                                        (step === 2) ?
                                            <svg width="24" height="24" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29628)">
                                                    <rect y="0.5" width="24" height="24" rx="12" fill="#ECFAFD" />
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M17.0965 7.89004L9.9365 14.8L8.0365 12.77C7.6865 12.44 7.1365 12.42 6.7365 12.7C6.3465 12.99 6.2365 13.5 6.4765 13.91L8.7265 17.57C8.9465 17.91 9.3265 18.12 9.7565 18.12C10.1665 18.12 10.5565 17.91 10.7765 17.57C11.1365 17.1 18.0065 8.91004 18.0065 8.91004C18.9065 7.99004 17.8165 7.18004 17.0965 7.88004V7.89004Z" fill="#2DA6C0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29628">
                                                        <rect y="0.5" width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                            :
                                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <g clip-path="url(#clip0_613_29582)">
                                                    <rect width="24" height="24" rx="12" fill="#F9FAFB" />
                                                    <circle cx="12" cy="12" r="4" fill="#EAECF0" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_613_29582">
                                                        <rect width="24" height="24" rx="12" fill="white" />
                                                    </clipPath>
                                                </defs>
                                            </svg>
                                }
                            </div>
                        </div>
                    </Col>

                    <Col sm={12} className={styles.colWithNoSidePaddings}>
                        {
                            isLoading === false ?
                                (<Container className={styles.colWithNoSidePaddings}>
                                    {/* Rendering Content Goes Here */}
                                    {step === 1 && props.showModal === true && <EmailDetails isChecked={isEmailActive} setIsEmailActive={setIsEmailActive} onSubmitEmailData={onSubmitEmailData} closeModal={props.handleClose} emailData={emailData}/>}
                                    {step === 2 && props.showModal === true && <EmailReview previousPage={previousPage} handleClose={props.handleClose} getPipelineValues={props.getPipelineValues} emailData={emailData} isChecked={isEmailActive} submitEmailTemplateValues={submitEmailTemplateValues} submissionLoading={submissionLoading}/>}
                                </Container>)
                                : (<div className='mt-5'>
                                    <Col sm={{ span: 4, offset: 4 }}>
                                        <CSSLoader />
                                    </Col>
                                </div>)
                        }
                    </Col>
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default RejectionEmailModal;
